module.exports = __webpack_public_path__ + "static/img/14.5cab1d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/14.png
// module id = FKfo
// module chunks = 0